var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rtc-stream"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.anchorShareStream),expression:"anchorShareStream"}],staticClass:"share-stream",attrs:{"id":"share-stream"}}),_c('div',{staticClass:"stream",class:_vm.anchorShareStream ? 'small-stream' : '',attrs:{"id":"main-stream"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }